<template>
  <div class="buttons-set">
    <div>
      <transition name="scroll-button">
        <jobs-scroll-button
          v-if="showSeeJobsScrollBtn && show"
          key="'scroll-to-jobs-list'"
          :button-classes="'is-dark-gray'"
          :button-text="labels.seeJobsText"
          @click="scrollToElement(jobsListTitleId)">
          <svg-icon slot="icon" name="arrow-down" width="16" height="16"></svg-icon>
        </jobs-scroll-button>
        <jobs-scroll-button
          v-else-if="show"
          key="'scroll-to-filters'"
          :button-classes="'is-secondary filter-results'"
          :button-text="labels.filterResultsText"
          @click="scrollToElement(filtersId)">
          <filter-icon slot="icon"></filter-icon>
        </jobs-scroll-button>
      </transition>
    </div>
  </div>
</template>

<script>

import FilterIcon from 'top20common/components/icons/FilterIcon';
import {mapGetters} from 'vuex';

import JobsScrollButton from './JobsScrollButton';

export default {
  props: {
    filtersId: String,
    jobsListTitleId: String,
    show: Boolean
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  data() {
    return {
      showSeeJobsScrollBtn: true
    };
  },
  computed: {
    ...mapGetters(['jobsCountState', 'jobsActiveFiltersState']),
    labels() {
      return {
        seeJobsText: this.$gettextInterpolate(
          this.$ngettext('See %{amount} job', 'See %{amount} jobs', this.jobsCountState),
          {amount: this.jobsCountState}
        ),
        filterResultsText: this.$gettext('Filter results')
      };
    },
    jobsListTitleEl() {
      return document.getElementById(this.jobsListTitleId);
    },
    filtersEl() {
      return document.getElementById(this.filtersId);
    }
  },
  methods: {
    isElementVisible(el) {
      const scroll = window.scrollY || window.pageYOffset;
      const boundsTop = el.getBoundingClientRect().top + scroll;

      const viewport = {top: scroll, bottom: scroll + window.innerHeight};
      const bounds = {top: boundsTop, bottom: boundsTop + el.clientHeight};

      return (
        (bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom) ||
        (bounds.top <= viewport.bottom && bounds.top >= viewport.top)
      );
    },
    scrollToElement(elementId) {
      const element = document.getElementById(elementId);
      this.$scrollTo(element, {offset: 1});
    },
    handleScroll() {
      this.showSeeJobsScrollBtn = this.isElementVisible(this.filtersEl);
    }
  },
  components: {
    JobsScrollButton,
    FilterIcon
  }
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

.scroll-button-enter-active,
.scroll-button-leave-active {
  transition: all 0.3s;
}

.scroll-button-enter,
.scroll-button-leave-to {
  opacity: 0;
  transform: translateY(100px);
}

@media (max-width: $tablet) {
  .buttons-set {
    margin: 10px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    user-select: none;

    .button {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 10px;
      z-index: 1;
    }
  }
}
</style>
